import { createSelector } from 'reselect'
import getCurrentSidebarSelect from 'modules/sidebar/redux/selectors/get-current'

/**
 * @param state
 * @returns {Object}
 */
const getCurrentDataSidebarSelect = createSelector(
  getCurrentSidebarSelect,
  sidebar => sidebar?.data
)

export default getCurrentDataSidebarSelect
